<template>
  <div class="post-revisions-container">
    <div class="post-revisions-header">
      <h5>Post Revisions</h5>
      <DpplSwitch
        :value="isScore"
        left="Score"
        right="Date"
        @change="handleScoreChange"
      />
    </div>
    <div
      class="revisions-chart"
    >
      <RevisionsBubbleChart
        v-if="isScore"
        data-testid="revisions-bubble-chart"
      />
      <RevisionsLineChart
        v-else
        data-testid="revisions-line-chart"
      />
    </div>
  </div>
</template>

<script>
import RevisionsBubbleChart from '@/components/settings/usage/RevisionsBubbleChart.vue';
import RevisionsLineChart from '@/components/settings/usage/RevisionsLineChart.vue';
import DpplSwitch from '@/components/datapeople/DpplSwitch.vue';

export default {
  name: 'UsagePostRevisions',
  components: {
    RevisionsBubbleChart,
    RevisionsLineChart,
    DpplSwitch,
  },
  data() {
    return {
      isScore: true,
    };
  },
  computed: {
    toggleLabel() {
      return this.isScore ? 'Score' : 'Date';
    },
  },
  mounted() {
    if (this.$route.query.is_post_revisions_score) {
      this.isScore = this.$route.query.is_post_revisions_score === 'true';
    } else {
      this.$router.replace({
        query: {
          ...this.$route.query,
          is_post_revisions_score: this.isScore,
        },
      });
    }
  },
  methods: {
    handleScoreChange(value) {
      this.isScore = value;
      this.$router.replace({
        query: {
          ...this.$route.query,
          is_post_revisions_score: this.isScore,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '@/less/mixins';

.post-revisions-container {
  background: @white;
  width: calc(100% - 366px);
  height: 100%;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid @stroke-default;
}

.post-revisions-header {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;

  h5 {
    line-height: 30px;
  }

  :deep(.v-input--switch) {
    margin: 0px;
    padding: 0px;
  }
}

.revisions-chart {
  width: 100%;
  height: calc(100% - 40px);
}
</style>
